// Helpers de leitura de tokens de tema em runtime.
//
// Componentes JSX devem preferir CSS custom properties direto
// (style={{ color: 'var(--token-primary)' }}). Esses helpers existem para
// charts e libs que precisam de hex literal em JS (ApexCharts/Chart.js)
// e para callers que querem ler o objeto de tema da marca ativa.

import brand from '@configs/brand'
import { storage } from './storage'

const isDarkSkin = (skin) => skin === 'dark' || skin === 'semi-dark'

// Lê o skin atual da mesma fonte que ThemeContext usa (storage 'skin').
// Fallback para 'light' quando indefinido — alinhado a themeConfig.layout.skin.
export const getActiveSkin = () => {
  try {
    const stored = storage.get('skin')
    return stored !== undefined ? stored : 'light'
  } catch {
    return 'light'
  }
}

// Retorna o objeto theme.light ou theme.dark da marca ativa.
// Usar como fonte de verdade quando precisa de hex literal em JS (ex.: charts).
export const getActiveTheme = () => {
  const skin = getActiveSkin()
  return isDarkSkin(skin) ? brand.theme.dark : brand.theme.light
}

// Lê uma CSS custom property aplicada no body — preferencial sobre
// hex literais em código JS. Retorna fallback quando o DOM ainda não montou.
export const getCSSVar = (name, fallback = '') => {
  if (typeof window === 'undefined' || !window.document?.body) return fallback
  const value = window.getComputedStyle(window.document.body).getPropertyValue(name)
  return (value && value.trim()) || fallback
}

// Açúcar para tokens de marca: getToken('primary') => '#7D45DC' do tema ativo.
export const getToken = (key, fallback = '') => {
  const cssName = `--token-${key}`
  return getCSSVar(cssName, fallback)
}
